import { ReactNode } from 'react';

function Num({ value, def = '0' }: { value?: number; def?: ReactNode }) {
  return <>{!value ? def : Number(value).toLocaleString()}</>;
}

export default Num;
